import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div<{ $error?: boolean; $bare?: boolean }>`
  display: flex;
  align-items: stretch;
  border: ${(p) => (p.$bare ? 'none' : `1px solid ${p.$error ? colors.error : colors.borderGrey}`)};
  border-radius: ${(p) => (p.$bare ? '0' : '8px')};
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 1;

  &:focus-within {
    z-index: 100;
  }
`;

export const CountryCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-right: 1px solid ${colors.borderGrey};
  position: relative;
  z-index: 10;

  & button {
    border: none;
    border-radius: 0;
    background: transparent;
    min-width: unset;
    width: auto;
    padding: ${layout.inputPadding};
    gap: ${space[2]};

    &:focus,
    &[data-open='true'] {
      border: none;
      background: ${colors.lighterGrey};
    }

    & > :last-child {
      display: none;
    }
  }
`;

export const FlagCircle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  font-size: ${fonts.size.base};
  line-height: 1;
`;
